import api from "./app-controller";
import CART_ENDPOINTS from "../routes/cart-routes";

export const getUserCart = async () => await api.get(`${CART_ENDPOINTS.GET_CART}`);
export const addItemToUserCart = async (body) => await api.post(`${CART_ENDPOINTS.ADD_TO_CART}`, body);
export const updateUserCart = async (body) => await api.put(`${CART_ENDPOINTS.UPDATE_CART}`, body);
export const removeItemFromUserCart = async (body) => await api.post(`${CART_ENDPOINTS.DELETE_FROM_CART}`, body);
export const addAddressToUserCart = async (body) => await api.put(`${CART_ENDPOINTS.ADD_ADDRESS}`, body);
export const checkoutUserCart = async (body) => await api.post(`${CART_ENDPOINTS.CHECKOUT}`, body);
export const getClientSecret = async (body) => await api.post(`${CART_ENDPOINTS.GET_CLIENT_SECRET}`, body);